export default __webpack_public_path__ + "dccba3e68efc5e15a98ea6173452fe50.png";